import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentClearDelete = {
    path: "/consent/clear",
    method: RouteHttpVerb.DELETE,
    obfuscatePath: "keep-last-part"
};
